import { render, staticRenderFns } from "./ComposerSessionIndicator.vue?vue&type=template&id=a14d9e0e&scoped=true"
import script from "./ComposerSessionIndicator.vue?vue&type=script&lang=js"
export * from "./ComposerSessionIndicator.vue?vue&type=script&lang=js"
import style0 from "./ComposerSessionIndicator.vue?vue&type=style&index=0&id=a14d9e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14d9e0e",
  null
  
)

export default component.exports